<template>
  <div class="container">
    <div class="header-img">
      <img src="../../assets/images/savecoupon/bg.png" alt="">
    </div>
    <div>
      <div class="content-wrapper" v-if="showLogin">
        <form action=""  class="custom-form">
          <div class="form-item">
            <div class="form-control">
              <input name="phone" type="text" maxlength="11" class="form-input" placeholder="请输入手机号" v-model="phone">
            </div>
          </div>
          <div class="form-item form-code-item">
            <div class="form-control">
              <input class="form-input" name="authcode" maxlength="10" type="text" placeholder="请输入验证码" v-model="authcode">
            </div>
            <div class="form-code-line"></div>
            <button class="form-code-btn" :disabled="disabled" @click="sendCode">{{btntxt}}</button>
          </div>
          <div class="form-item form-item-button">
            <button class="form-button" type="submit" @click="formCodeSubmit">注册并领取优惠劵</button>
          </div>
        </form>
      </div>
      <div class="coupon-wrapper">
        <div class="coupon-btn" v-show="showLoginFlag">
          <img src="../../assets/images/savecoupon/btn.png" alt="" @click="handleCoupon">
        </div>
        <div>
          <coupon-list :couponList="couponList"></coupon-list>
        </div>
        <rule-page></rule-page>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { getRegister, getSendCode } from '@/api/khCoupon'
import { getCouponList, batchGet } from '@/api/couponSave'
import RulePage from './rule'
import CouponList from './couponList'
import { setStore } from '@/utils/index'

export default {
  components: {
    RulePage: RulePage,
    CouponList: CouponList
  },
  data () {
    return {
      activityId: null,
      showLogin: false,
      disabled: false,
      time: 0,
      btntxt: '获取验证码',
      phone: '',
      authcode: '',
      showLoginFlag: true,
      couponList: []
    }
  },
  created () {
    this.getIsWxClient()
    const token = this.$route.query.token
    this.activityId = this.$route.query.id
    if (token) {
      setStore('token', token)
      this.showLogin = false
      this.showLoginFlag = true
    } else {
      this.showLogin = true
      this.showLoginFlag = false
    }
    this.getList()
  },
  methods: {
    getList () {
      const requestData = {
        activityId: this.activityId
      }
      getCouponList(requestData).then((res) => {
        if (res.data.code === 200) {
          this.couponList = res.data.result || []
        } else {
          Toast({
            message: res.data.message
          })
        }
      })
    },
    handleCoupon () {
      this.getBatch()
    },
    formCodeSubmit (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.authcode) {
        Toast({
          message: '验证码不能为空'
        })
        return
      }
      let data = {
        clientId: 'bjqd-d11',
        loginType: 2,
        account: this.phone,
        authCode: this.authcode
      }
      getRegister(data).then((res) => {
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 3000
          })
        } else if (res.data.code === 200) {
          const token = res.data.result.accessToken
          setStore('token', token)
          this.getBatch()
        }
      })
    },
    getIsWxClient () {
      var ua = navigator.userAgent.toLowerCase()
      console.log(ua)
      // eslint-disable-next-line eqeqeq
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      }
      return false
    },
    getBatch () {
      const requestData = {
        activityId: this.activityId
      }
      batchGet(requestData).then((res) => {
        if (res.data.code === 200) {
          // 领劵成功
          if (this.getIsWxClient()) {
            Dialog.confirm({
              message: '恭喜您领券成功，快去使用吧~',
              confirmButtonText: '下载APP',
              cancelButtonText: '确认'
            }).then(() => {
              this.handleDown()
            })
          } else {
            Dialog({
              message: '恭喜您领券成功，快去使用吧~'
            })
          }
        }
      })
    },
    handleDown () {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    },
    checkPhone (phone) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    sendCode (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      } else if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
      let data = {
        clientId: 'bjqd-d11',
        phone: this.phone,
        type: 3
      }
      getSendCode(data).then((res) => {
        if (res.data.code === 50003) {
          Toast({
            message: '只有新用户才可领取此优惠！',
            duration: 1500
          })
        } else if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  min-height: 100vh;
  padding-bottom: 30px;
  background:#a7cdfb;
}
.header-img {
  img {
    width: 100%;
  }
}
.coupon-btn {
  margin: 10px 0 8px;
  text-align: center;
  img {
    width: 191px;
  }
}

/* 登录注册框 */
.content-wrapper {
  margin: 12px;
  padding: 12px 15px 1px 15px;
  border-radius: 5px;
  background: #fff;
  z-index: 100;
}
.custom-form {
  margin: 8px 0 15px;
  padding: 6px 0;
  border-radius: 5px;
  background: #f8f8f8;
}
.form-item {
  display: flex;
  align-items: center;
  margin:  10px 15px;
  border-radius: 5px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 15px 0  15px;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  margin-bottom: 10px;
  background-color: #FE4C31;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    line-height: 30px;
  }
}
.form-title {
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
}
.form-item-rule {
  margin: 0 auto;
  font-size: 15px;
  color: #666;
  text-align: center;
}
.form-control {
  width: 100%;
  background: #E4E4E4;
  padding: 8px 12px;
  border-radius: 5px;
}
.form-control.form-invite {
  font-size: 15px;
}
.form-input {
  width: 100%;
  height: 100%;
  background: #E4E4E4;
  outline: none;
  font-size: 15px;
}
.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto;
  padding: 8px 5px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  outline: none;
  background-color: #ec5a3f;
}
.form-down {
  position: absolute;
  right: 11%;
  text-align: center;
  background: #fff;
  text-decoration: underline;
  color: #666;
  font-size: 12px;
}
.form-code-item {
  background: #E4E4E4;
}
.form-code-line {
  background: #aaa;
  height: 12px;
  width: 1px;
  margin: 0 3px;
}
.form-code-btn {
  margin-left: 8px;
  padding: 8px 10px;
  height: 100%;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 14px;
  color: #333;
  line-height: 1;
  outline: none;
  background: #e4e4e4;
}
.form-code-btn:disabled {
  color: #FE4C31;
}
/* 优惠券 */
.coupon-wrapper {
  margin: 12px;
  padding: 15px 0;
  background: #fff;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
/* 规则 */
.rule-wrapper {
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
}
.rule-content {
  padding: 0 15px 15px 15px;
  background: #fff;
  border-radius: 10px;
}
.rule-item {
  .title {
    font-size: 14px;
    margin: 15px 0 6px;
    color: #282828;

  }
  .desc {
    line-height: 1.6;
    font-size: 12px;
    color: #999;
  }
}

</style>
